import { Box, CircularProgress } from '@mui/material';

export default function CenteredSpinner({ size = 24 }) {
  return (
    <Box className="flex justify-center items-center py-32">
      <CircularProgress size={size} />
    </Box>
  );
}
